"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var federalHolidays = {
  2019: [{
    date: '2019-01-01',
    holiday: "New Year's Day"
  }, {
    date: '2019-01-21',
    holiday: "Birthday of Martin Luther King"
  }, {
    date: '2019-02-18',
    holiday: "Washington's Birthday"
  }, {
    date: '2019-05-27',
    holiday: 'Memorial Day'
  }, {
    date: '2019-07-04',
    holiday: 'Independence Day'
  }, {
    date: '2019-09-02',
    holiday: 'Labor Day'
  }, {
    date: '2019-10-14',
    holiday: 'Columbus Day'
  }, {
    date: '2019-11-11',
    holiday: 'Veterans Day'
  }, {
    date: '2019-11-28',
    holiday: 'Thanksgiving'
  }, {
    date: '2019-12-25',
    holiday: 'Christmas Day'
  }],
  2020: [{
    date: '2020-12-25',
    holiday: 'Christmas Day'
  }],
  2021: [{
    date: '2021-01-01',
    holiday: "New Year's Day"
  }, {
    date: '2021-01-18',
    holiday: "Martin Luther King Jr. Day"
  }, {
    date: '2021-02-12',
    holiday: "Lincoln's Birthday"
  }, {
    date: '2021-02-15',
    holiday: "Washington's Birthday"
  }, {
    date: '2021-05-31',
    holiday: "Memorial Day"
  }, {
    date: '2021-07-05',
    holiday: "Independence Day"
  }, {
    date: '2021-09-06',
    holiday: "Labor Day"
  }, {
    date: '2021-10-11',
    holiday: "Columbus Day"
  }, {
    date: '2021-11-11',
    holiday: "Veterans Day"
  }, {
    date: '2021-11-25',
    holiday: "Thanksgiving"
  }, {
    date: '2021-12-24',
    holiday: "Christmas Day"
  }, {
    date: '2021-12-31',
    holiday: "New Year's Day"
  }]
};
var _default = federalHolidays;
exports["default"] = _default;